// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__8KzSU"};